import 'core-js/stable';
import Vue from 'vue';
import App from './App';
import router from './router';
import CoreuiVue from '@coreui/vue';
import { iconsSet as icons } from './assets/icons/icons.js';
import store from './store';
import i18n from './i18n';
import axios from "axios";
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT
const regeneratorRuntime = require("regenerator-runtime");

Vue.config.performance = true;
Vue.use(CoreuiVue);
Vue.use(VueSweetalert2);

i18n.locale = 'en';
Vue.config.lang = 'en';

const permissions = JSON.parse(localStorage.getItem('permissions', null));
store.dispatch('setPermissions', permissions);

new Vue({
  i18n,
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
});
